/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import { useState } from "react";

type Partial<T> = {
	[P in keyof T]?: T[P];
};
/**
 * Хук принимает на вход объект для проверки,
 * массив ключей этого объекта,
 * функцию, которая будет выполняться по успешному завершению проверки
 *
 * Хук предназначен для проверки наличия чего-нибудь в этом поле, для продвинутой валидации нужна будет прокачка
 *
 * Возвращает булевое значение наличия ошибки, и функцию которая собственно и будет делать проверку,
 * по успешному завершению будет вызывать переданную третьим аргументом функцию
 *
 * @template  T
 * @param {T} data - объект состояния
 * @param {Array<keyof typeof T>} required - массив обязательных ключей
 * @param {function():void} func
 */
export function useValidate<T>(
	data: T,
	required: Array<keyof Partial<T>>,
	func: () => void,
): { error: boolean; validate: () => void } {
	const [validate, setValidate] = useState(false);
	const validateFields = () => {
		let newTypeKey: keyof typeof data;
		for (newTypeKey in data) {
			if (required.includes(newTypeKey) && !data[newTypeKey]) {
				setValidate(true);
				setTimeout(() => {
					setValidate(false);
				}, 3000);
				return;
			}
		}
		func();
	};
	return { error: validate, validate: validateFields };
}
